<div class="relative w-full max-w-none h-[90vh] overflow-y-auto">
  <div
    class="bg-white/95 backdrop-blur-md border-b border-slate-200 p-6"
  >
    <div
      class="w-full h-[30vh] aspect-[16/9] rounded-lg overflow-hidden mb-6"
      *ngIf="news && news.image"
    >
      <img
        [src]="news.image + news.imageToken"
        alt="Image de l'article"
        class="w-full h-full object-cover"
      />
    </div>
    <div class="flex items-start justify-between">
      <div class="flex-1 mr-8">
        <div class="flex items-center flex-wrap gap-2 mb-3">
          <ng-container *ngIf="showMotCles && news?.motCles?.length">
            <span
              *ngFor="let tag of news?.motCles"
              class="bg-primary-100 text-primary-800 px-2 py-1 rounded-full text-xs font-semibold"
            >
              {{ tag }}
            </span>
          </ng-container>
          <ng-container *ngIf="showMotsCles && news?.motCles?.length">
            <span
              *ngFor="let motCle of news?.motCles"
              class="bg-primary-100 text-primary-800 px-2 py-1 rounded-full text-xs font-semibold"
            >
              {{ motCle }}
            </span>
          </ng-container>
        </div>
        <h1
          class="text-2xl md:text-3xl font-bold text-slate-800 mb-4 leading-tight"
        >
          {{ news?.titre }}
        </h1>
        <div class="flex items-center text-sm text-slate-600 mb-2">
          <i class="pi pi-user mr-2"></i>
          <span class="font-semibold">{{ news?.auteur }}</span>
        </div>
        <div class="flex items-center text-sm text-slate-600">
          <i class="pi pi-clock mr-2"></i>
          <span class="font-semibold mr-1">{{ news?.jour }} </span>
          <span class="font-semibold">{{ news?.mois }}</span>
        </div>
      </div>
    </div>
  </div>

 <div class="p-8 md:p-12 min-h-32 news-content">
    <div class="max-w-none">
      <div
        class="prose prose-lg max-w-none break-words whitespace-pre-line"
        [innerHTML]="processedContent"></div>
    </div>
  </div>
</div>
